import { createRouter, createWebHistory } from 'vue-router';
import AllParcs from '../views/AllParks.vue';
import Weather from '../views/Weather.vue';

const routes = [
  {
    path: '/',
    name: 'AllParks',
    component: AllParcs
  },
  {
    path: '/weather/:city',
    name: 'Weather',
    component: Weather,
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
